
import request from '@/utils/request'

export function getListProductApi(query) {
  return request({
    url: '/config-service/v1/product',
    method: 'get',
    params: query
  })
}

export function addProductApi(query) {
  return request({
    url: '/config-service/v1/product',
    method: 'post',
    data: query
  })
}

export function updateProductApi(query) {
  return request({
    url: '/config-service/v1/product',
    method: 'put',
    data: query
  })
}

export function deleteProductApi(query) {
  return request({
    url: '/config-service/v1/product',
    method: 'delete',
    data: query
  })
}

export function getProductTemplateExcelApi() {
  return request({
    url: '/config-service/v1/product/excel-template',
    method: 'get',
    responseType: 'arraybuffer'
  })
}

export function getProductExcelApi(query) {
  return request({
    url: '/config-service/v1/product/export-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

export function addProductExcelApi(data) {
  return request({
    url: '/config-service/v1/product/import-excel',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
